import * as types from '@/store/mutation-types';

const state = {
  userPool: null,
  user: {},
  device: {},
};

const getters = {
  user(state) {
    return state.user;
  },
  userPool(state) {
    return state.userPool;
  },
  device(state) {
    return state.device;
  },
};

const mutations = {
  [types.SET_USER](state, { user }) {
    state.user = user;
  },
  [types.LOGOUT_USER](state) {
    state.user = {};
  },
  [types.SET_USER_POOL](state, pool) {
    state.userPool = pool;
  },
  [types.SET_DEVICE](state, device) {
    state.device = device;
  },
  [types.SET_GLOBAL_VALUE](state, p) {
    p.item[p.key] = p.value;
  },
  [types.UPDATE_USER](state, { updates = [], users = [] }) {
    const update = ({ user, updates }) => {
      updates.forEach((update) => {
        const keys = update.key.split('.');
        let data = user;
        let lastKey;
        keys.forEach((key, i) => {
          if (i === keys.length - 1) {
            lastKey = key;
          } else {
            data = data[key];
          }
        });
        data[lastKey] = update.value;
      });
    };
    update({ updates, user: state.user });
    const user = users.find(user => user.id === state.user.id);
    if (user) {
      update({ updates, user });
    }
  },
  [types.REMOVE_USER](state, { users = [], user }) {
    const userIndex = users.findIndex(u => u.id === user.id);
    if (userIndex > -1) {
      users.splice(userIndex, 1);
    }
  },
  [types.RESET_USER](state, {
    updated,
  }) {
    if (updated.id === state.user.id) {
      state.user = updated;
    }
  },
  [types.RUN_GLOBAL_FN](state, { fn }) {
    fn();
  },
};

const actions = {
  setUser({ commit }, params) {
    commit(types.SET_USER, params);
  },
  logoutUser({ commit }) {
    commit(types.LOGOUT_USER);
  },
  setDeviceInfo({ commit }, params) {
    commit(types.SET_DEVICE, params);
  },
  updateUser({ commit, rootState }, params) {
    commit(types.UPDATE_USER, { ...params, users: rootState.admin.users });
  },
  removeUser({ commit, rootState }, params) {
    commit(types.REMOVE_USER, {
      ...params,
      users: rootState.admin.users,
    });
  },
  resetUser({ commit }, params) {
    commit(types.RESET_USER, params);
  },
  setUserPool({ commit }, payload) {
    commit(types.SET_USER_POOL, payload);
  },
  setGlobalValue({ commit }, payload) {
    commit(types.SET_GLOBAL_VALUE, payload);
  },
  runGlobalFn({ commit }, payload) {
    commit(types.RUN_GLOBAL_FN, payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
